// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M11 10L8 13L5 10M5 6L8 3L11 6'];
